import { render, staticRenderFns } from "./GridFotos.vue?vue&type=template&id=037f2e3e&scoped=true"
import script from "./GridFotos.vue?vue&type=script&lang=js"
export * from "./GridFotos.vue?vue&type=script&lang=js"
import style0 from "./GridFotos.vue?vue&type=style&index=0&id=037f2e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037f2e3e",
  null
  
)

export default component.exports